export const env = {
  PRODUCT_ID: import.meta.env.VITE_PRODUCT_ID || "audiencias",
  CLIENT_ID: import.meta.env.VITE_CLIENT_ID || "default",
  BASE_URL: import.meta.env.VITE_APP_BASEURL || "",
  BASE_URL_SITE: import.meta.env.VITE_APP_BASEURL_SITE || "",
  STORAGE_BASE_URL: import.meta.env.VITE_APP_STORAGE_BASE_URL || "",
  AVAILABLE_LANGUAGES: (
    import.meta.env.VITE_AVAILABLE_LANGUAGES || "pt-BR,pt-PT,en-US,es-ES"
  ).split(",") as string[],
  LANGUAGE_SELECTOR_ENABLED:
    import.meta.env.VITE_LANGUAGE_SELECTOR_ENABLED !== "false",
  DEFAULT_LANGUAGE: import.meta.env.VITE_DEFAULT_LANGUAGE || "pt-BR",
} as const;
